import { useDispatch, useSelector } from "react-redux";

/**
 * Pre-typed dispatch hook. Use throughout the app instead of plain `useDispatch`.
 */
export const useAppDispatch = () => useDispatch();

/**
 * Pre-typed selector hook. Use throughout the app instead of plain `useSelector`.
 */
export const useAppSelector = useSelector;
